import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { JointImage } from "shared/JointImage";
import { CardContainer, Container, headerFont } from "routes/createContent/components/styles";

import { GET_TEMPLATE } from "./__mocks__";
import { useParams } from "react-router-dom";
import { LibraryItem } from "../../components/LibraryItem/LibraryItem";
import { PremiumIcon } from "shared";
import { LogoIcon } from "assets";

export const Template: React.VFC = () => {
  const { t } = useTranslation();
  const { id } = useParams() as any;
  const data = GET_TEMPLATE;

  // @ts-ignore
  const name = data?.key ? t(`usercourse.templates.standardized.name.${data.key}`) : data?.name || id;
  const image = data?.key ? <JointImage id={data.key} /> : undefined;

  return (
    <div>
      <h1>Template</h1>
      <p>Details of the template will be displayed here.</p>

      <Container>
        <Header>
          {image && <ImageContainer>{image}</ImageContainer>}
          <h2>{name}</h2>
          {!data?.standardized && (
            <>Icon</>
            // <IconButton
            //   onClick={() => navigate(`/library/your-library/templates/${id}/edit`)}
            //   size="large"
            //   style={{ marginLeft: "auto" }}
            // >
            //   <EditIcon />
            // </IconButton>
          )}
        </Header>

        <Section>
          <span>
            {t("usercourse.exercise_per_day")} {data?.max_exercises_per_day}
          </span>
          <span>
            {t("usercourse.function_test")} {data?.functional_test ? t("buttons.yes") : t("buttons.no")}
          </span>
          <span>
            {/* @ts-ignore */}
            {t("usercourse.health_form_type")} {t(`usercourse.healthformtype.${data?.health_form_type || "generic"}`)}
          </span>
        </Section>

        <Section>
          <SectionHeader>{t("usercourse.exercises")}</SectionHeader>
          {data?.exercises?.length ? (
            <CardContainer>
              {data.exercises.map(exercise => {
                const { id, title } = exercise.levels[0];
                const caption =
                  exercise.levels.length > 0 ? `${exercise.levels.length} ${t("usercourse.levels")}` : undefined;

                return (
                  <LibraryItem
                    key={`exercise_${exercise.id}`}
                    caption={caption}
                    checked={false}
                    icon={exercise.premium ? <PremiumIcon size="small" premiumType="guided_care" /> : undefined}
                    id={id}
                    image={<img alt="" src={`${exercise.levels[0].image_url}`} height="100%" />}
                    tags={exercise.target_joints}
                    title={title}
                  />
                );
              })}
            </CardContainer>
          ) : (
            <div>No exercises added</div>
          )}
        </Section>

        <Section>
          <SectionHeader>{t("usercourse.lessons")}</SectionHeader>
          {data?.lessons?.length ? (
            <CardContainer>
              {data.lessons.map(lesson => {
                const { id, title } = lesson;
                const caption = lesson.parts_count ? `${lesson.parts_count} ${t("usercourse.parts")}` : undefined;
                const image = lesson.image_url ? (
                  <img alt="" src={`${lesson.image_url}`} height="100%" />
                ) : (
                  <LogoIcon title="Joint Academy" />
                );

                return (
                  <LibraryItem
                    key={`lesson_${lesson.id}`}
                    caption={caption}
                    checked={false}
                    id={id}
                    image={image}
                    tags={lesson.target_joints}
                    title={title}
                  />
                );
              })}
            </CardContainer>
          ) : (
            <div>No lessons added</div>
          )}
        </Section>
      </Container>
    </div>
  );
};

const Header = styled.header`
  display: flex;
  align-items: center;
  gap: 24px;

  & > h2 {
    ${headerFont}
  }
`;

const ImageContainer = styled.div`
  width: 60px;
  height: 60px;

  & > svg {
    height: 100%;
    width: 100%;
  }
`;

const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SectionHeader = styled.h3`
  margin: 0;
`;
